// @flow

// NOTE: This Flow module has a corresponding ambient TypeScript declaration in app/types/flow-modules.d.ts. Keep them in sync until this file is migrated to TypeScript.

import {normalizeCustomerDocument} from '@tectonics/prs/core/customer/normalize';
import {
  GenericValidationMessage,
} from '@tectonics/look-and-feel/volcanes/pages/page-opened-payment/customer-form/generic';
import {formatValueWithMask} from '@tectonics/components/input-mask';
import type {DocumentConfig} from '@tectonics/commons/customer-form/types';

const EIGHT_NUMERIC_DIGIT_MASK = [
  /[0-9]/, /[0-9]/, /[0-9]/,
  /[0-9]/, /[0-9]/, /[0-9]/,
  /[0-9]/, /[0-9]/,
];

export const genericDocument: DocumentConfig = {
  inputFieldName: 'genericDocument',
  specDocumentName: 'field_generic_document',
  mask: EIGHT_NUMERIC_DIGIT_MASK,
  normalizer: normalizeCustomerDocument,
  labelKey: 'volcanes.customerForm.document.label',
  validationError: GenericValidationMessage,
  formatFunction: formatValueWithMask,
};
